<div class="linq-popover {{ panelClass }}">
	<ng-content></ng-content>
</div>
